import styled from "styled-components";

export const Wrapper = styled.div`
  /* margin-bottom: 15px; */
  display: flex;
  flex-direction: ${(p) => (p.stack ? "column" : "row")};
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
`;

export const Right = styled.div`
  display: flex;
  flex-direction: ${(p) => (p.stack ? "column" : "row")};

  & > button {
    margin-left: 5px;
  }

  &:last-child {
    margin-right: 0px;
  }
`;
